import { Button, Dropdown, Menu } from 'antd';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AppState } from 'interface/stateApp';
import AuthForm from './Login';
import { clearAllStorage, getAuthenticator } from 'utils/localStorage';
import { isValid } from 'utils/helper';
import { useMasterUserSelector } from '../../redux/selector';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../redux/store/store';
import { clearUserInfo, fetchUserInf } from '../../redux/slice/masterDataSlice';
import './header.scss';
import { unwrapResult } from '@reduxjs/toolkit';
import { UserRole } from '../../model/enum';
import { hasPermission } from '../../utils/utils';
import { ContainerOutlined, DashboardOutlined, FundProjectionScreenOutlined } from '@ant-design/icons';

interface MenuNode {
  icon: ReactNode;
  title: string;
  url: string;
  roles?: UserRole[];
}

const menuNodes: MenuNode[] = [
  {
    title: 'Dashboard',
    icon: <DashboardOutlined className="text-[25px] text-gray-500" />,
    url: '/dashboard',
    roles: ['ROLE_ADMIN'],
  },
  {
    title: 'E-book',
    icon: <img src="/e-book.png" width={32} height={32} alt="" className="mx-auto" />,
    url: '/electronic-book/book',
    roles: ['ROLE_ADMIN'],
  },
  {
    title: 'Thiết lập chung',
    icon: <img src="/court.png" width={32} height={32} alt="" className="mx-auto" />,
    url: '/master-setting',
    roles: ['ROLE_ADMIN'],
  },
  {
    title: 'Đề thi',
    icon: <img src="/pdf.png" width={32} height={32} alt="" className="mx-auto" />,
    url: '/exam-management',
    roles: ['ROLE_ADMIN', 'ROLE_COMPILER', 'ROLE_MASTER_COMPILER'],
  },
  {
    title: 'Đề tự luyện',
    icon: <FundProjectionScreenOutlined className="text-[25px] text-gray-500" />,
    url: '/practice-management',
    roles: ['ROLE_ADMIN', 'ROLE_COMPILER', 'ROLE_MASTER_COMPILER'],
  },
  {
    title: 'Ngân hàng câu hỏi',
    icon: <ContainerOutlined className="text-[25px] text-gray-500" />,
    url: '/question-bank',
    roles: ['ROLE_ADMIN', 'ROLE_COMPILER', 'ROLE_MASTER_COMPILER'],
  },
  {
    title: 'Hỏi đáp',
    icon: <img src="/question-mark.png" width={32} height={32} alt="" className="mx-auto" />,
    url: '/qna-tickets/tickets/all',
    roles: ['ROLE_ADMIN', 'ROLE_EXPERT', 'ROLE_TEACHER', 'ROLE_CTV'],
  },
  {
    title: 'Người dùng',
    icon: <img src="/group.png" width={32} height={32} alt="" className="mx-auto" />,
    url: '/user-management/user',
    roles: ['ROLE_ADMIN'],
  },
];

export default function Header() {
  const [stateApp, setStateApp] = useState<AppState>({
    typeHover: '',
    typeHoverSubMenu: '',
    idKeyboard: '',
    answer: [],
    loading: false,
    showLoginForm: false,
    showRegisterForm: false,
    isLogin: false,
    showActiveBookForm: false,
  });
  const user = useMasterUserSelector();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();

  const autoLogin = () => {
    if (isValid(getAuthenticator() && user === null)) {
      dispatch(fetchUserInf()).then(unwrapResult).then();
    }
  };
  useEffect(() => {
    autoLogin();
  }, []);

  const handleLogout = () => {
    // logout process
    clearAllStorage();
    dispatch(clearUserInfo());
    navigate('/');
  };

  const authorizedMenuNodes = useMemo(() => {
    return menuNodes.filter((menuItem) => hasPermission(menuItem.roles, user));
  }, [user]);

  function getActiveClassName(menuItem: MenuNode) {
    const firstLocationPart = location.pathname.split('/')[1];
    const firstMenuPart = menuItem.url.split('/')[1];
    return firstLocationPart === firstMenuPart ? 'bg-[#e6f8ff]' : '';
  }

  return (
    <header className="w-full flex sticky top-0 flex-shrink-0 justify-between shadow-md z-[100] bg-white overflow-x-auto header-container">
      {user ? (
        <div className="flex px-8 items-center">
          <Link to={'/'}>
            <img src="/assets/images/img_logo.png" className="w-[auto] h-[72px] mr-2" alt="" />
          </Link>
          {authorizedMenuNodes.map((menuItem) => (
            <Link
              to={menuItem.url}
              key={menuItem.url}
              className={'w-[160px] hover:bg-[#e6f8ff] py-4 ' + getActiveClassName(menuItem)}
            >
              {menuItem.icon}
              <div className="text-[18px] font-medium text-[#a3a3a3]">{menuItem.title}</div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="flex px-8 items-center">
          <Link to={'/'}>
            <img src="/assets/images/img_logo.png" className="w-[auto] h-[72px] mr-2" alt="" />
          </Link>
        </div>
      )}

      <div className="flex gap-4 items-center mr-6">
        {user ? (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item key="2">
                  <Button type="text" onClick={handleLogout}>
                    Đăng xuất
                  </Button>
                </Menu.Item>
              </Menu>
            }
            trigger={['click']}
          >
            <div className="flex-col items-center cursor-pointer justify-center">
              <img src="/avartar.png" alt="" className="w-[28px] h-[28px] text-center mx-auto"></img>
              <p className="text-center">{user?.firstName}</p>
            </div>
          </Dropdown>
        ) : (
          <Button
            className="text-[18px] font-medium text-[#a3a3a3]"
            onClick={() =>
              setStateApp({
                ...stateApp,
                showLoginForm: true,
              })
            }
          >
            Đăng nhập
          </Button>
        )}
        <AuthForm stateApp={stateApp} setStateApp={setStateApp}></AuthForm>
      </div>
    </header>
  );
}
